import React, { useEffect } from 'react'
import { Switch, Route, Redirect, RouteComponentProps } from 'react-router-dom'
import Components from './pages/Components/Components'
import Homepage from './pages/Homepage/Homepage'
import PersonalCourses from './pages/PesonalCourses/PersonalCourses'
import PersonalTests from './pages/PersonalTests/PersonalTests'
import SelectMore from './pages/SelectMore/SelectMore'
import Registration from './pages/Registration/Registration'
import Profile from './pages/Profile/Profile'
import ProfileEdit from './pages/Profile/ProfileEdit'
import Dashboard from './pages/Dashboard/Dashboard'
import { getCookie } from './services/utils'
import PasswordReset from './pages/PasswordReset/PasswordReset'
import OnlineCourses from './pages/OnlineCourses/OnlineCourses'
import OnlineCourse from './pages/OnlineCourse/OnlineCourse'
import OnlineMockExamCourses from './pages/OnlineMockExamCourses/OnlineMockExamCourses'
import PersonalCourse from './pages/PersonalCourse/PersonalCourse'
import PersonalTest from './pages/PersonalTest/PersonalTest'
// import FreeCourse from './pages/FreeCourse/FreeCourse';
// import OpenFreeCourse from './pages/OpenFreeCourse/OpenFreeCourse';
import Overview from './pages/Overview/Overview'
import OnlineMockExamCourse from './pages/OnlineMockExamCourse/OnlineMockExamCourse'
import Footer from './components/TheFooter/Footer'
import FrontFooter from './components/Front/Footer/Footer'
import FrontHeader from './components/Front/Header/Header'
import FrontHomepage from './pages/Front/Homepage/Homepage'
import Contact from './pages/Front/Contact/Contact'
import AboutUs from './pages/Front/AboutUs/AboutUs'
import PnAll from './pages/Front/PnAll/PnAll'
import PkAll from './pages/Front/PkAll/PkAll'
import Pk5Online from './pages/Front/Pk5Online/Pk5Online'
import OnlineSchool from './pages/Front/OnlineSchool/OnlineSchool'
import PrivateClass from './pages/Front/PrivateClass/PrivateClass'
import Pk7Online from './pages/Front/Pk7Online/Pk7Online'
import Pk9Online from './pages/Front/Pk9Online/Pk9Online'
import Pk9 from './pages/Front/Pk9/Pk9'
import Pn5 from './pages/Front/Pn5/Pn5'
import Pn7 from './pages/Front/Pn7/Pn7'
import Pn9 from './pages/Front/Pn9/Pn9'
import Pn9Online from './pages/Front/Pn9Online/Pn9Online'
import Pn7Online from './pages/Front/Pn7Online/Pn7Online'
import Pn5Online from './pages/Front/Pn5Online/Pn5Online'
import Gdpr from './pages/Front/Gdpr/Gdpr'
import Rent from './pages/Front/Rent/Rent'
import SignIn from './pages/SignIn/SignIn'

type RoutesType = {
  path: string
  title: string
  component: React.FC<{}>
  protected: boolean
  exact?: boolean
  authPage?: boolean
  layout: 'APP' | 'FRONT'
}[]
interface PageType extends RouteComponentProps {
  component: React.FC<any>
  title: string
  layout: 'APP' | 'FRONT'
}

declare global {
  interface Window {
    router: any
    toggleNotification: any
  }
}

export const routesURLs = {
  dashboard: '/app/dashboard',
  onlineCourse: '/app/dashboard/online-kurz',
  personalCourse: '/app/dashboard/kurz-na-miste',
  freeCourse: '/app/dashboard/lekce-zdarma',
  openFreeCourse: '/app/lekce-zdarma',
  personalCourses: '/app/kurzy-na-miste',
  onlineCourses: '/app/online-kurzy',
  selectMore: '/app/dalsi-kurzy',
  registration: '/app/registrace',
  profile: '/app/profil',
  overview: '/app/prehled',
  profileEdit: '/app/nastaveni-profilu',
  passwordReset: '/app/obnova-hesla',
  components: '/app/components',
  signin: '/app/prihlaseni',
  onlineMockExamCourse: '/app/dashboard/online-prijimacky-nanecisto',
  onlineMockExamCourses: '/app/online-prijimacky-nanecisto',
  personalTests: '/app/prijimacky-na-miste',
  personalTestsWithCourse: '/app/prijimacky-na-miste/:id',
  personalTest: '/app/dashboard/prijimacky-na-miste',
  homepage: '/app',
  contact: '/kontakt',
  aboutUs: '/o-nas',
  pnAll: '/prijimacky-nanecisto',
  pkAll: '/pripravne-kurzy',
  pk5Online: '/pripravne-kurzy/5-trida/online',
  pk7Online: '/pripravne-kurzy/7-trida/online',
  pk9Online: '/pripravne-kurzy/9-trida/online',
  pk9: '/pripravne-kurzy/9-trida/prezencne',
  pn5: '/prijimacky-nanecisto/5-trida/prezencne',
  pn7: '/prijimacky-nanecisto/7-trida/prezencne',
  pn9: '/prijimacky-nanecisto/9-trida/prezencne',
  pn5Online: '/prijimacky-nanecisto/5-trida/online',
  pn7Online: '/prijimacky-nanecisto/7-trida/online',
  pn9Online: '/prijimacky-nanecisto/9-trida/online',
  onlineSchool: '/online-skola',
  privateClass: '/osobni-doucovani',
  gdpr: '/zasady-ochrany-osobnich-udaju',
  rent: '/pronajem-prostor',
  fronthomepage: '/'
}
export const routesList: RoutesType = [
  /*
    {
        path: routesURLs.openFreeCourse,
        title: 'Lekce ZDARMA',
        component: OpenFreeCourse,
        protected: false,
        topbarType: 'freeCourse',
    },
    */
  {
    path: routesURLs.personalCourses,
    title: 'Kurzy na místě',
    component: PersonalCourses,
    protected: false,
    layout: 'APP'
  },
  {
    path: routesURLs.onlineCourses,
    title: 'On-line kurzy',
    component: OnlineCourses,
    protected: false,
    layout: 'APP'
  },
  {
    path: routesURLs.selectMore,
    title: 'Další kurzy',
    component: SelectMore,
    protected: false,
    layout: 'APP'
  },
  {
    path: routesURLs.selectMore,
    title: 'Další kurzy',
    component: SelectMore,
    protected: false,
    layout: 'APP'
  },
  {
    path: routesURLs.registration,
    title: 'Registrace',
    component: Registration,
    protected: false,
    authPage: true,
    layout: 'APP'
  },
  {
    path: routesURLs.profile,
    title: 'Profil',
    component: Profile,
    protected: true,
    layout: 'APP'
  },
  {
    path: routesURLs.overview,
    title: 'Přehled',
    component: Overview,
    protected: true,
    layout: 'APP'
  },
  {
    path: routesURLs.profileEdit,
    title: 'Nastavení profilu',
    component: ProfileEdit,
    protected: true,
    layout: 'APP'
  },
  {
    path: routesURLs.passwordReset,
    title: 'Obnova hesla',
    component: PasswordReset,
    protected: false,
    authPage: true,
    layout: 'APP'
  },
  {
    path: routesURLs.components,
    title: 'Komponenty',
    component: Components,
    protected: false,
    layout: 'APP'
  },
  {
    path: routesURLs.personalTests,
    title: 'Přijímačky nanečisto',
    component: PersonalTests,
    protected: false,
    layout: 'APP'
  },
  {
    path: routesURLs.personalTestsWithCourse,
    title: 'Přijímačky nanečisto',
    component: PersonalTests,
    protected: false,
    layout: 'APP'
  },
  /*
    {
        path: routesURLs.freeCourse,
        title: 'Lekce zdarma',
        component: FreeCourse,
        protected: true,
        topbarType: 'personal',
    },
    */
  {
    path: routesURLs.personalCourse,
    title: 'Kurz na místě',
    component: PersonalCourse,
    protected: true,
    layout: 'APP'
  },
  {
    path: routesURLs.onlineCourse,
    title: 'On-line kurz',
    component: OnlineCourse,
    protected: true,
    layout: 'APP'
  },
  {
    path: routesURLs.personalTest,
    title: 'Přijímačky na místě',
    component: PersonalTest,
    protected: true,
    layout: 'APP'
  },
  {
    path: routesURLs.onlineMockExamCourses,
    title: 'On-line přijímačky nanečisto',
    component: OnlineMockExamCourses,
    protected: false,
    layout: 'APP'
  },
  {
    path: routesURLs.onlineMockExamCourse,
    title: 'On-line přijímačky nanečisto',
    component: OnlineMockExamCourse,
    protected: false,
    layout: 'APP'
  },
  {
    path: routesURLs.dashboard,
    title: 'Dashboard',
    component: Dashboard,
    protected: true,
    layout: 'APP'
  },
  {
    path: routesURLs.signin,
    title: 'Přihlášení',
    component: SignIn,
    protected: false,
    authPage: true,
    layout: 'APP'
  },
  {
    path: routesURLs.homepage,
    title: 'Homepage',
    component: Homepage,
    protected: false,
    exact: true,
    layout: 'APP'
  },
  {
    path: routesURLs.fronthomepage,
    title: 'Kompletní příprava na střední školy',
    component: FrontHomepage,
    protected: false,
    layout: 'FRONT',
    exact: true
  },
  {
    path: routesURLs.contact,
    title: 'Kontakt',
    component: Contact,
    protected: false,
    layout: 'FRONT',
    exact: true
  },
  {
    path: routesURLs.aboutUs,
    title: 'O nás',
    component: AboutUs,
    protected: false,
    layout: 'FRONT',
    exact: true
  },
  {
    path: routesURLs.pnAll,
    title: 'Přijímačky nanečisto',
    component: PnAll,
    protected: false,
    layout: 'FRONT',
    exact: true
  },
  {
    path: routesURLs.pkAll,
    title: 'Přípravné kurzy',
    component: PkAll,
    protected: false,
    layout: 'FRONT',
    exact: true
  },
  {
    path: routesURLs.pk5Online,
    title: 'Přípravné kurzy',
    component: Pk5Online,
    protected: false,
    layout: 'FRONT',
    exact: true
  },
  {
    path: routesURLs.privateClass,
    title: 'Osobní doučování',
    component: PrivateClass,
    protected: false,
    layout: 'FRONT',
    exact: true
  },
  {
    path: routesURLs.onlineSchool,
    title: 'Online škola',
    component: OnlineSchool,
    protected: false,
    layout: 'FRONT',
    exact: true
  },
  {
    path: routesURLs.pk7Online,
    title: 'Online škola',
    component: Pk7Online,
    protected: false,
    layout: 'FRONT',
    exact: true
  },
  {
    path: routesURLs.pk9Online,
    title: 'Online škola',
    component: Pk9Online,
    protected: false,
    layout: 'FRONT',
    exact: true
  },
  {
    path: routesURLs.pk9,
    title: 'Online škola',
    component: Pk9,
    protected: false,
    layout: 'FRONT',
    exact: true
  },
  {
    path: routesURLs.pn5,
    title: 'Online škola',
    component: Pn5,
    protected: false,
    layout: 'FRONT',
    exact: true
  },
  {
    path: routesURLs.pn7,
    title: 'Online škola',
    component: Pn7,
    protected: false,
    layout: 'FRONT',
    exact: true
  },
  {
    path: routesURLs.pn9,
    title: 'Online škola',
    component: Pn9,
    protected: false,
    layout: 'FRONT',
    exact: true
  },
  {
    path: routesURLs.pn9Online,
    title: 'Online škola',
    component: Pn9Online,
    protected: false,
    layout: 'FRONT',
    exact: true
  },
  {
    path: routesURLs.pn7Online,
    title: 'Online škola',
    component: Pn7Online,
    protected: false,
    layout: 'FRONT',
    exact: true
  },
  {
    path: routesURLs.gdpr,
    title: 'GDPR',
    component: Gdpr,
    protected: false,
    layout: 'FRONT',
    exact: true
  },
  {
    path: routesURLs.pn5Online,
    title: 'Online škola',
    component: Pn5Online,
    protected: false,
    layout: 'FRONT',
    exact: true
  },
  {
    path: routesURLs.rent,
    title: 'Pronájem prostor',
    component: Rent,
    protected: false,
    layout: 'FRONT',
    exact: true
  }
]

const Routes: React.FC = () => {
  return (
    <Switch>
      {routesList.map((route, key) => (
        <Route
          key={key}
          path={route.path}
          exact={route.exact || false}
          render={(props) => {
            if (route.authPage && getCookie('jid')) {
              return <Redirect to="/app/dashboard" />
            } else if (route.protected && !getCookie('jid')) {
              return <Redirect to="/app" />
            } else {
              return (
                <Page
                  {...props}
                  component={route.component}
                  title={route.title}
                  layout={route.layout}
                />
              )
            }
          }}
        />
      ))}
      <Redirect to="/app" />
    </Switch>
  )
}

export const Page: React.FC<PageType> = (props) => {
  const { title, component, layout } = props
  const PageComponent = component

  if (!window.router) {
    window.router = props.history
  }

  useEffect(() => {
    document.title = title ? `${title} · DOHLAVY` : 'DOHLAVY'
  }, [title])

  return (
    <>
      <FrontHeader />
      {layout === 'APP' && <div className="h-[90px]"></div>}
      <div className={`page-content ${layout === 'FRONT' && 'front-page-content'}`}>
        <PageComponent props={props as PageType} />
      </div>
      {layout === 'FRONT' ? <FrontFooter /> : <Footer />}
    </>
  )
}

export default Routes
